package com.patronat.top.features.usermanagement.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.UserStatus
import com.patronat.top.features.usermanagement.domain.repository.ProfileRepository

data class UpdateUserStatusCommand(
    val userId: String,
    val newStatus: UserStatus
)

class UpdateUserStatusUseCase(
    private val profileRepository: ProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<UpdateUserStatusCommand, DomainResult<Unit>>(dispatcherProvider.io) {
    override suspend fun doWork(command: UpdateUserStatusCommand): DomainResult<Unit> {
        return profileRepository.updateUserStatus(command.userId, command.newStatus)
    }
}